import { ModelMixin } from '../core/base-generic.model';
import { Employee } from '../employee/employee.model';
import { ApplicantInterviewerFeedback } from './applicant-interviewer-feedbacks.model';
import { ApplicantInterviews } from './applicant-interviews.model';
import { InterviewQuestion } from './interview-question.model';

export class ApplicantInterviewers extends ModelMixin<ApplicantInterviewers>() {
    protected static _resource = 'applicantTracker/applicantInterviewers';
    protected static _version = 'v2';
    protected static _serializeAttributes = ['isSubmitted', 'evaluation'];
    protected static _datetimes = ['feedbackDueDate', 'createdAt', 'updatedAt', 'deletedAt'];

    get atsApplicantInterviewId(): number {
        return this._attributes['atsApplicantInterviewId'];
    }

    set atsApplicantInterviewId(val: number) {
        this._attributes['atsApplicantInterviewId'] = val;
    }

    get interviewerId(): number {
        return this._attributes['interviewerId'];
    }

    set interviewerId(val: number) {
        this._attributes['interviewerId'] = val;
    }

    get status(): string {
        return this._attributes['status'];
    }

    get isSubmitted(): boolean {
        return this._attributes['isSubmitted'];
    }

    set isSubmitted(val: boolean) {
        this._attributes['isSubmitted'] = val;
    }

    get evaluation(): string {
        return this._attributes['evaluation'];
    }

    set evaluation(val: string) {
        this._attributes['evaluation'] = val;
    }

    get isPendingFeedback(): boolean {
        return this._attributes['isPendingFeedback'];
    }

    set isPendingFeedback(val: boolean) {
        this._attributes['isPendingFeedback'] = val;
    }

    get applicantInterview(): ApplicantInterviews {
        return this.hasOne(ApplicantInterviews, 'applicantInterview');
    }

    get interviewQuestions(): InterviewQuestion[] {
        return this.hasMany(InterviewQuestion, 'interviewQuestions');
    }

    set interviewQuestions(interviewQuestions: InterviewQuestion[]) {
        this.setMany('interviewQuestions', interviewQuestions);
    }

    get interviewer(): Employee {
        return this.hasOne(Employee, 'interviewer');
    }

    get applicantInterviewerFeedbacks(): ApplicantInterviewerFeedback[] {
        return this.hasMany(ApplicantInterviewerFeedback, 'applicantInterviewerFeedbacks');
    }
}
